export default "__VITE_ASSET__a5ae5d05__"